var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('MainMenu',{attrs:{"quantity":_vm.quantity}}),_c('v-layout',{attrs:{"column":""}},[_c('v-layout',[_c('v-flex',[_c('router-view')],1)],1),_c('v-layout',{attrs:{"align-end":""}},[_c('v-flex',{staticClass:"footer-wrap"},[_c('div',{staticClass:"page-content-paddings"},[_c('AppFooter',{staticClass:"mb-3"})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }